import React from 'react';
import { linksPropTypes } from './LinksPropTypes';
import Heading from '@Theme/natucare/modules/Footer/components/Heading/Heading';
import * as styles from './Links.module.scss';
const Links = ({
  heading,
  items
}) => {
  if (!items) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Heading, {
    heading: heading
  }), /*#__PURE__*/React.createElement("ul", {
    className: styles.rootList
  }, items.map(({
    label,
    href
  }, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.rootListLink,
    href: href,
    dangerouslySetInnerHTML: {
      __html: label
    }
  })))));
};
export default Links;